import { render, staticRenderFns } from "./WorkFlowGraph.vue?vue&type=template&id=5d8397b8&scoped=true"
import script from "./WorkFlowGraph.vue?vue&type=script&lang=js"
export * from "./WorkFlowGraph.vue?vue&type=script&lang=js"
import style0 from "./WorkFlowGraph.vue?vue&type=style&index=0&id=5d8397b8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d8397b8",
  null
  
)

export default component.exports